/** Title-case each word in a person name (e.g. "nico creemers" → "Nico Creemers"). */
export function formatPersonName(name) {
  if (!name || typeof name !== 'string') return '';

  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split('-')
        .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : ''))
        .join('-')
    )
    .join(' ');
}

/** Logged-in team member name for quote advisor field. */
export function formatAdvisorName(user, fallback = '') {
  if (!user) return fallback;
  const name = formatPersonName(`${user.first_name || ''} ${user.last_name || ''}`.trim());
  return name || fallback;
}
